import { render, staticRenderFns } from "./checkLastname.vue?vue&type=template&id=04d228bf&scoped=true&"
import script from "./checkLastname.vue?vue&type=script&lang=js&"
export * from "./checkLastname.vue?vue&type=script&lang=js&"
import style0 from "./checkLastname.vue?vue&type=style&index=0&id=04d228bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d228bf",
  null
  
)

export default component.exports